import React, { useMemo, useState } from 'react';
import { useMonitoramento } from '../../context/MonitoramentoContext';
import { classificarMensagem, isContingencia } from '../../utils/classificarMensagem';
import { parseServerDate } from '../../utils/serverDate';

function formatarData(dataInput) {
  return parseServerDate(dataInput).toLocaleString('pt-BR');
}

const LogContingencia = () => {
  const { pdvData } = useMonitoramento();
  const [busca, setBusca] = useState('');

  const registros = useMemo(() => {
    const ocorrencias = (pdvData || [])
      .filter(r => r.cnpj !== '11111111111111')
      .filter(r => isContingencia(r.mensagem));

    const termo = busca.trim().toLowerCase();
    const filtradas = termo
      ? ocorrencias.filter(r =>
          (r.nome || '').toLowerCase().includes(termo) ||
          (r.cnpj || '').toLowerCase().includes(termo)
        )
      : ocorrencias;

    return [...filtradas].sort((a, b) => parseServerDate(b.recepcao) - parseServerDate(a.recepcao));
  }, [pdvData, busca]);

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ maxWidth: 280 }}
          placeholder="Filtrar por cliente ou CNPJ..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
        {busca && (
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setBusca('')}>
            Limpar ×
          </button>
        )}
        <small className="text-muted ms-auto">{registros.length} ocorrência(s)</small>
      </div>

      <div className="cs-cont-log">
        {registros.length > 0 ? (
          registros.map((registro) => {
            const classificacao = classificarMensagem(registro.mensagem);
            return (
              <div key={registro.controle} className={`cs-cont-line cs-sev-${classificacao.sev}`}>
                <span className="cs-cont-time">{formatarData(registro.recepcao)}</span>
                <span className="cs-cont-cliente">{registro.nome}</span>
                <span className="cs-cont-msg" dangerouslySetInnerHTML={{ __html: registro.mensagem }} />
              </div>
            );
          })
        ) : (
          <div className="alert alert-info" role="alert">
            Nenhuma ocorrência de contingência encontrada.
          </div>
        )}
      </div>
    </div>
  );
};

export default LogContingencia;
